// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__25_Hq","slider-inner":"styles_slider-inner__25eeV"};